import React, { useMemo } from 'react';
import * as R from 'ramda';

import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { inspectionDataOrder } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import './collinsMpcPdfReport.css';

interface Props {
  workOrder: any;
  workOrderAsset: any;
}

const InspectionData = ({ workOrder, workOrderAsset }: Props) => {
  const data = getAttributeDataRows(
    workOrderAsset?.attributes,
    inspectionDataOrder,
  );

  const mainPhoto = useMemo(() => {
    if (!isNilOrEmpty(workOrder)) {
      return R.find(R.propEq('id', workOrder?.mainPhotoId))(
        workOrder?.media?.media,
      );
    }

    return {};
  }, [workOrder]);

  const photoStyle = {
    backgroundImage: `url('${FILES_ENDPOINT}/${mainPhoto?.fileId}_360')`,
  };

  return (
    <div styleName="section-box no-margin">
      <div styleName="section-title">Inspection Data</div>
      <div styleName="inspection-content">
        <div styleName="left-box">
          {data.map(attribute => {
            return (
              <div styleName="data-row" key={attribute?.id}>
                <div styleName="data-title">{`${attribute?.name}:`}</div>
                <div styleName="data-content">
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div styleName="photo-box">
          {!isNilOrEmpty(mainPhoto) && (
            <div styleName="photo" style={photoStyle} />
          )}
        </div>
      </div>
    </div>
  );
};

export default InspectionData;
